export const SERVLET_ACTION = 'Action'

/**
 * Servlet actions.
 */
export enum ServletActions {
    GET = 'Get',
    SHOW_ADD = 'ShowAdd',
    SHOW_CHG = 'ShowChange',
    DELETE = 'Delete',
    CSV_FILE_UPLOAD = 'BULK_ADD_USERS_CSV_FILE_UPLOAD',
    CONFIRM_FILE = 'BULK_ADD_USERS_CSV_DATA_CONFIRMED',
    CANCEL_FILE = 'BULK_ADD_USERS_PROCESS_CANCEL',
    COPY = 'Copy',
    RENAME = 'RENAME',
    REPORT_CHANGE = 'Change',
    REPORT_ADD = 'Add',
    REPORT_MOVE_TO_BIN = 'MoveToBin',
    REPORT_RESTORE_FROM_BIN = 'RestoreFromBin',
    REPORT_DELETE_FROM_BIN = 'DeleteFromBin'
}
